import React from 'react';

const MadingSection = () => {
    // const { data: madingData, loading, error } = useApi(apiService.getMading);
    const mading={
        MadingJudul: "Mading",
        MadingDeskripsi: "Menampilkan hasil karya siswa-siswi MAN 1 Jember.",
        MadingCard:{
            MadingCardJudul: "Karya siswa-siswi",
            MadingCardDeskripsi: "Kami menyediakan mading terbaru yang informatif dan menarik untuk Anda.",
            MadingCardDeskripsi2: "Ingin menjadi penulis mading? Daftarkan diri Anda sekarang!",
        }
    }
      const adminLink = import.meta.env.VITE_ADMIN_URL

  return (
    <section id="mading" className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center justify-center heading-circle-icon bg-primary-100 rounded-full mb-6">
              <i className="fas fa-newspaper heading-icon text-primary-600"></i>
            </div>
          <h2 className="heading-primary">{mading.MadingJudul}</h2>
          <p className="text-body max-w-3xl mx-auto mb-8">{mading.MadingDeskripsi}</p>

        </div>
        <div className='bg-gray-50 rounded-2xl shadow-lg p-8 border border-gray-100'>
            <div className="mb-8 " >
                <div className="lg:w-20 w-12 lg:h-20 h-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-book-open lg:text-2xl text-base text-white"></i>
                </div>
                <div className='text-center mb-4'>
                    <h3 className="lg:text-2xl text-base font-bold text-gray-900 lg:mb-4 mb-2">{mading.MadingCard.MadingCardJudul}</h3>
                    <p className="text-gray-600 lg:mb-8 mb-5 lg:text-lg text-xs">{mading.MadingCard.MadingCardDeskripsi}</p>
                </div>
                {/* button untuk mengarak ke link */}
                <div className="text-center">
                    <a href="/mading" className="btn btn-primary">
                        Lihat Mading
                    </a>
                </div>

                <div className="text-center pt-6">
                    <p className="text-gray-600 lg:mb-8 mb-5 lg:text-lg text-xs">{mading.MadingCard.MadingCardDeskripsi2}</p>
                    <a href={adminLink} className="btn btn-primary">
                        Mendaftar
                    </a>
                </div>

            </div>
        </div>
      </div>
    </section>
  );
}
export default MadingSection;